import axios from 'axios'
import injectBaseParamsDefault from './interceptors/request/injectBaseParamsDefault'
import { camelizeKeysInterceptor } from './interceptors/response/camelizeKeysInterceptor'
import { createNetworkRetryInterceptor } from './interceptors/response/networkRetryInterceptor'
import { responseErrorInterceptor } from './interceptors/response/responseErrorInterceptor'
import { addAxiosDebugInterceptors } from './interceptors/debug/debugLogInterceptor'

const retryClient = axios.create({
  timeout: 15000,
  headers: { 'Cache-Control': 'no-store, no-cache', Pragma: 'no-cache' }
})

addAxiosDebugInterceptors(retryClient, 'refresh')

retryClient.interceptors.request.use(
  injectBaseParamsDefault,
  (error) => Promise.reject(error)
)

retryClient.interceptors.response.use(
  undefined,
  createNetworkRetryInterceptor(retryClient, {
    includeTimeouts: true,
    retryStatusCodes: [500, 502, 503, 504]
  })
)

retryClient.interceptors.response.use(
  camelizeKeysInterceptor,
  responseErrorInterceptor
)

export default retryClient
